/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Abt_Contact_TitleInputs */

const en_mk_abt_contact_title = /** @type {(inputs: Mk_Abt_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Talking to us`)
};

const id_mk_abt_contact_title = /** @type {(inputs: Mk_Abt_Contact_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mau bicara dengan kami`)
};

/**
* | output |
* | --- |
* | "Talking to us" |
*
* @param {Mk_Abt_Contact_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_abt_contact_title = /** @type {((inputs?: Mk_Abt_Contact_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Abt_Contact_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_abt_contact_title(inputs)
	return en_mk_abt_contact_title(inputs)
});